import { render } from "./SingleView.vue?vue&type=template&id=2b14ab26"
import script from "./SingleView.vue?vue&type=script&lang=js"
export * from "./SingleView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__